import { connect } from 'react-redux';
import Sidebar from './Sidebar';

const mapStateToProps = ({ user }) => ({
  user,
});

const mapDispatchToProps = () => ({});

const SidebarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Sidebar);

export default SidebarContainer;



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarContainer.js